import React from 'react';
import PropTypes from 'prop-types';
import DropdownLookupForm from '../../DropdownLookupForm';
import MultiSectionLookupForm from '../../MultiSectionLookupForm';


const ModalBody = function ModalBody({
  content,
  sectionOptions,
  programOptions,
  formValues,
  updateFormValues,
  submitForm,
  showDisclaimer,
}) {
  const {
    disclaimer,
  } = content;
  const FormComponent = sectionOptions ? MultiSectionLookupForm : DropdownLookupForm;

  return (
    <div className="opco-nav-form__container">
      <FormComponent
        sectionOptions={sectionOptions}
        programOptions={programOptions}
        content={content}
        formValues={formValues}
        updateFormValues={updateFormValues}
        submitForm={submitForm}
      />
      {showDisclaimer && (
        <div className="opco-nav-form__disclaimer">
          {disclaimer}
        </div>
      )}
    </div>
  );
};

ModalBody.propTypes = {
  content: PropTypes.shape({
    disclaimer: PropTypes.string,
  }).isRequired,
  programOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sectionOptions: PropTypes.arrayOf(PropTypes.shape({})),
  formValues: PropTypes.shape({}).isRequired,
  updateFormValues: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  showDisclaimer: PropTypes.bool.isRequired,
};

ModalBody.defaultProps = {
  sectionOptions: null,
};

export default ModalBody;
